'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Modal = require('components/Modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TimeBar, _Component);

  function TimeBar(props) {
    (0, _classCallCheck3.default)(this, TimeBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TimeBar.__proto__ || (0, _getPrototypeOf2.default)(TimeBar)).call(this, props));

    _this.showHoverPopup = function (e) {
      var hoveredElement = e.target;
      if (hoveredElement.classList.contains('clickable')) {
        var position = hoveredElement.getBoundingClientRect();

        _this.setState({
          showingPopup: true,
          popupTitle: hoveredElement.getAttribute('data-hover-title'),
          popupText: hoveredElement.getAttribute('data-hover-text'),
          popupPosition: {
            left: position.left - 80,
            bottom: window.innerHeight - position.top + 10 - 80
          }
        });
      }
    };

    _this.hideHoverPopup = function (e) {
      _this.setState({
        showingPopup: false
      });
    };

    _this.state = {
      showingPopup: false,
      popupTitle: '',
      popupText: '',
      popupPosition: {
        left: 0,
        bottom: 0
      }
    };

    _this.showHoverPopup = _this.showHoverPopup.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(TimeBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          points = _props.points,
          relativeProgress = _props.relativeProgress,
          handleClick = _props.handleClick;

      var pointsToRender = [];
      var totalCount = 0;
      var littleClass = void 0,
          bigClass = void 0;
      for (var i = 0; i < points.length; i++) {
        if (i > 0) {
          var howMany = points[i].leftPos - points[i - 1].leftPos - 1;
          for (var j = 0; j < howMany; j++) {
            totalCount++;
            littleClass = (0, _classnames2.default)({
              'filled': totalCount <= relativeProgress,
              'littlePoints': true
            });
            pointsToRender.push(_react2.default.createElement('span', { className: littleClass, key: "littlePoint" + i + "" + j }));
          }
        }
        totalCount++;
        bigClass = (0, _classnames2.default)({
          'clickable': totalCount < relativeProgress,
          'point': true
        });
        pointsToRender.push(_react2.default.createElement(
          'span',
          { className: bigClass, key: "point" + i, 'data-hover-title': points[i].hoverTitle, 'data-hover-text': points[i].hoverText, 'data-message-id': points[i].messageId, 'data-media-id': points[i].mediaId, onMouseOver: this.showHoverPopup, onMouseOut: this.hideHoverPopup, onClick: handleClick },
          _react2.default.createElement('span', { className: 'littlePoint' })
        ));
      }

      return _react2.default.createElement(
        'div',
        { className: 'time' },
        pointsToRender,
        _react2.default.createElement(_Modal.HoverPopup, { show: this.state.showingPopup, title: this.state.popupTitle, text: this.state.popupText, position: this.state.popupPosition })
      );
    }
  }]);
  return TimeBar;
}(_react.Component), _class.propTypes = {
  points: _react.PropTypes.array,
  relativeProgress: _react.PropTypes.number
}, _temp);
exports.default = TimeBar;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/TimeBar.js
// module id = 800
// module chunks = 0